// Inicio de Vanguardia 360: qué necesita atención hoy y el atajo a la entrada única.
import { Link } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { Boton, EsqueletoTabla, Pill, PuntoNaranja, TituloPagina, Vacio } from "@iavmx/ui";
import { useBandeja, useConSesion } from "./consultas";
import { useSesion } from "../sesion";
import { Sem } from "./componentes";
import { fechaCorta, fechaLarga, tonoEstado } from "./util";

export function InicioCampanas() {
  const { entrar, configuracion, persona } = useSesion();
  const conSesion = useConSesion();
  const q = useBandeja();
  const titulo = (
    <TituloPagina descripcion="Solicitudes, tareas por área, fechas límite y semáforo de riesgo para Mercadotecnia.">
      Vanguardia 360
      <PuntoNaranja />
    </TituloPagina>
  );
  if (!conSesion)
    return (
      <>
        {titulo}
        <Vacio
          titulo="Entra con tu cuenta de Vanguardia"
          texto="Las solicitudes, campañas y avisos solo se ven con sesión."
          accion={
            configuracion?.supabaseUrl ? (
              <Boton variante="acento" onClick={() => void entrar()}>
                Entrar con Google
              </Boton>
            ) : undefined
          }
        />
      </>
    );
  if (q.isLoading) return <>{titulo}<EsqueletoTabla columnas={3} /></>;
  if (q.error || !q.data) return <>{titulo}<Vacio titulo="No se pudo cargar" texto={q.error?.message} /></>;
  const d = q.data;
  const atencion = d.filas.filter((f) => f.semaforo === "en_riesgo" || f.semaforo === "atencion" || f.estadoSolicitud === "incompleta").slice(0, 6);
  const cifras: [string, number, string][] = [
    ["En riesgo", d.porSemaforo.en_riesgo, "/campanas"],
    ["Atención", d.porSemaforo.atencion, "/campanas"],
    ["Incompletas", d.conteos["Incompleta"] ?? 0, "/campanas"],
    ["Abiertas", d.total, "/campanas"],
  ];
  return (
    <>
      <TituloPagina
        descripcion={`${persona ? `Hola, ${persona.nombre.split(" ")[0]}. ` : ""}${fechaLarga(d.hoy)}.`}
        accion={
          <Boton variante="acento" asChild>
            <Link to="/campanas/nueva">
              <Plus /> Nueva solicitud
            </Link>
          </Boton>
        }
      >
        Vanguardia 360
      </TituloPagina>
      <dl className="mb-8 grid grid-cols-2 gap-px border border-linea bg-linea md:grid-cols-4">
        {cifras.map(([e, n, to]) => (
          <div key={e} className="bg-fondo p-4">
            <dt className="font-ui text-[11px] font-bold uppercase tracking-wide text-tinta-tenue">{e}</dt>
            <dd className="mt-1 font-titulo text-4xl font-bold tabular-nums">
              <Link to={to} className="hover:underline">
                {n}
              </Link>
            </dd>
          </div>
        ))}
      </dl>
      <h2 className="mb-2 font-titulo text-xl font-bold">Lo que pide atención</h2>
      {atencion.length === 0 ? (
        <p className="font-ui text-sm text-tinta-tenue">Nada en riesgo ni incompleto. Todo en fecha.</p>
      ) : (
        <ul className="divide-y divide-linea border-y border-linea">
          {atencion.map((f) => (
            <li key={f.solicitudId} className="flex flex-wrap items-center gap-2 py-3 font-ui text-sm">
              <Sem semaforo={f.semaforo} />
              <Link to={f.campanaId ? "/campanas/$id" : "/campanas/solicitudes/$id"} params={{ id: f.campanaId ?? f.solicitudId }} className="font-semibold text-tinta hover:underline">
                {f.titulo}
              </Link>
              <span className="text-tinta-tenue">{f.motivo}</span>
              <span className="ml-auto flex items-center gap-2">
                <span className="text-xs text-tinta-tenue">publica {fechaCorta(f.fechaPublicacion)}</span>
                <Pill tono={tonoEstado(f.estado)}>{f.estado}</Pill>
              </span>
            </li>
          ))}
        </ul>
      )}
      <div className="mt-6 flex flex-wrap gap-4 font-ui text-sm">
        <Link to="/campanas" className="text-azul hover:underline">
          Ver la bandeja
        </Link>
        <Link to="/campanas/calendario" className="text-azul hover:underline">
          Calendario de la semana
        </Link>
        <Link to="/campanas/historial" className="text-azul hover:underline">
          Historial y aprobaciones
        </Link>
      </div>
    </>
  );
}
